import { IEnvironment } from './environment-interface';

export const environment: IEnvironment = {
  production: false,
  staging: true,
  apiBasePaths: {
    uaa: 'https://uaa-service-staging.renovationman.com',
  },
  uiBasePaths: {
    artisan: 'https://espace-artisan-staging.renovationman.com',
    client: 'https://espace-client-staging.renovationman.com',
    employe: 'https://espace-employe-staging.renovationman.com',
    partner: 'https://espace-partenaire-staging.renovationman.com',
  },
};
